"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = require("../Field");
var Dropdown_1 = __importDefault(require("../../../misc/Dropdown"));
var styles_1 = require("../SelectInput/styles");
var typography_1 = require("../../../typography");
var Options_1 = __importDefault(require("./Options"));
var styles_2 = require("./styles");
function MultiSelectInput(_a) {
    var ariaLabel = _a.ariaLabel, id = _a.id, options = _a.options, placeholder = _a.placeholder, _b = _a.value, value = _b === void 0 ? [] : _b, label = _a.label, error = _a.error, disabled = _a.disabled, required = _a.required, hint = _a.hint, props = __rest(_a, ["ariaLabel", "id", "options", "placeholder", "value", "label", "error", "disabled", "required", "hint"]);
    var hasValue = value.length > 0;
    return (react_1.default.createElement(Field_1.Field, { id: id, label: label, required: required, error: error, hint: hint },
        react_1.default.createElement(styles_2.Wrapper, { "data-component-name": "MultiSelectInput", role: "listbox", "aria-label": label || ariaLabel },
            react_1.default.createElement(Dropdown_1.default, { anchor: function (_a) {
                    var isOpen = _a.isOpen, props = __rest(_a, ["isOpen"]);
                    return (react_1.default.createElement(styles_2.InputWrapper, __assign({}, props, { error: error, disabled: disabled }),
                        react_1.default.createElement(typography_1.Body, { level: "3", inline: true, color: hasValue ? 'currentColor' : 'GREY_60' }, value.length > 0
                            ? value
                                .map(function (v) { var _a; return (_a = options.find(function (option) { return option.value === v; })) === null || _a === void 0 ? void 0 : _a.display; })
                                .filter(Boolean)
                                .join(', ')
                            : placeholder),
                        react_1.default.createElement(styles_1.Chevron, { name: isOpen ? 'chevron-up' : 'chevron-down' })));
                } }, function () { return react_1.default.createElement(Options_1.default, { value: value, options: options, onChange: props.onChange }); }))));
}
exports.default = MultiSelectInput;
